module.exports = "<div class=\"container\">\n  <page-header title=\"Settings\">\n  </page-header>\n\n  <div class=\"bg-white tiled\">\n    <ul class=\"tab-nav\">\n      <li ng-class=\"{'active': $ctrl.isActive(menuItem)}\" ng-if=\"$ctrl.isAvailable(menuItem.permission)\" ng-repeat=\"menuItem in $ctrl.settingsMenu.menus\">\n        <a href=\"{{menuItem.path}}\">{{menuItem.title}}</a>\n      </li>\n\n    </ul>\n    <div class=\"p-15\">\n      <div ng-transclude>\n\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/settings-screen.html
// module id = 431
// module chunks = 1